import React from 'react';
import { Alert, Text } from '@amzn/storm-ui';
import { useTranslation } from 'react-i18next';

export function NotFound(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <Alert variant="error" header={t('page-not-found-header')}>
      <Text>{t('page-not-found-message')}</Text>
    </Alert>
  );
}
